export interface Review {
  name: string
  quote: string
  job: string
}

export const reviews: Review[] = [
  {
    name: 'Brant McManamon',
    job: 'Tile roof deep clean',
    quote:
      'The best in the business! JR and his team did a deep clean on my roof and did an amazing job. I have a very steep and large tile roof, and their team did a fantastic job and at a great price. They earn my #1 recommendation for exterior cleaning!',
  },
  {
    name: 'Ryan Stanley',
    job: 'Roof moss removal',
    quote:
      'JR did a great job cleaning the moss from my roof! Now he\u2019s going to clean my gutters and soft wash the house. If you\u2019re looking for a great company then use North Star. Highly recommended.',
  },
  {
    name: 'Jose Gonzalez',
    job: 'Exterior cleaning',
    quote: 'Very professional, on time and on budget. Highly recommended!',
  },
]
